module.exports = __webpack_public_path__ + "static/media/schedule-empty.c8c21446.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/schedule/schedule-empty.png
// module id = 2048
// module chunks = 6